import React, { type FC } from 'react';
import { Trans } from '@wix/wix-i18n-config';
import { Text, TextButton } from '@wix/design-system';
import { ROUTES } from '../../../../constants/routes';
import { DataHooks } from '../../../../constants/dataHooks';
import { useTemplatesPageBi } from '../../../../hooks/useTemplatesPageBi';
import { useTemplatesData } from '../../../../hooks/useTemplatesData';

export enum PrerequisiteStep {
  NodeJS = 'NodeJS',
  NpmDocs = 'NpmDocs',
  WixDeveloperAccount = 'WixDeveloperAccount',
  YarnDocs = 'YarnDocs',
  GitDocs = 'GitDocs',
  CliLearnMore = 'CliLearnMore',
}

export const prerequisiteSteps: Record<PrerequisiteStep, string> = {
  [PrerequisiteStep.NodeJS]: ROUTES.NodeJS,
  [PrerequisiteStep.NpmDocs]: ROUTES.NpmDocs,
  [PrerequisiteStep.YarnDocs]: ROUTES.YarnDocs,
  [PrerequisiteStep.WixDeveloperAccount]: ROUTES.WixDeveloperAccount,
  [PrerequisiteStep.GitDocs]: ROUTES.GitDocs,
  [PrerequisiteStep.CliLearnMore]: ROUTES.CliLearnMore,
};

export const PreSteps: FC = () => {
  const { currentTemplate: template } = useTemplatesData();
  const { reportCliPrerequisiteLinkClick } = useTemplatesPageBi();
  const onLinkClick = (name: PrerequisiteStep) => {
    const link = prerequisiteSteps[name];
    reportCliPrerequisiteLinkClick(template.id, name, link);
    window.open(link);
  };
  return (
    <Text dataHook={DataHooks.CLIModalPreStepsList} listStyle="circle">
      <ul>
        <li>
          <Trans i18nKey="app.template-page.modal.cli.step.1">
            <TextButton
              dataHook={`cli-prestep-${PrerequisiteStep.NodeJS}`}
              onClick={() => onLinkClick(PrerequisiteStep.NodeJS)}
            >
              NodeJS
            </TextButton>
          </Trans>
        </li>
        <li>
          <Trans i18nKey="app.template-page.modal.cli.step.2">
            <TextButton
              dataHook={`cli-prestep-${PrerequisiteStep.NpmDocs}`}
              onClick={() => onLinkClick(PrerequisiteStep.NpmDocs)}
            >
              NPM
            </TextButton>
            <TextButton
              dataHook={`cli-prestep-${PrerequisiteStep.YarnDocs}`}
              onClick={() => onLinkClick(PrerequisiteStep.YarnDocs)}
            >
              YARN
            </TextButton>
          </Trans>
        </li>
        <li>
          <Trans i18nKey="app.template-page.modal.cli.step.3">
            <TextButton
              dataHook={`cli-prestep-${PrerequisiteStep.GitDocs}`}
              onClick={() => onLinkClick(PrerequisiteStep.GitDocs)}
            >
              GIT
            </TextButton>
          </Trans>
        </li>
        <li>
          <Trans i18nKey="app.template-page.modal.cli.step.4">
            <TextButton
              dataHook={`cli-prestep-${PrerequisiteStep.WixDeveloperAccount}`}
              onClick={() => onLinkClick(PrerequisiteStep.WixDeveloperAccount)}
            >
              WIX DEVELOPER ACCOUNT
            </TextButton>
          </Trans>
        </li>
      </ul>
    </Text>
  );
};
